import { NotificationTypes } from "@lib/enums";

// Notifications only ever use one of three accent colors: green for
// opens/views, purple for candidate responses, orange for bounces/unsubscribes.
const GREEN = { accentColor: "#16A34A", iconBg: "#DCFCE7" };
const PURPLE = { accentColor: "#9747FF", iconBg: "#F3E8FF" };
const ORANGE = { accentColor: "#FF4400", iconBg: "#FFF0EB" };

export const accentMap = {
  [NotificationTypes.EMAIL_OPENED]: GREEN,
  [NotificationTypes.EMAIL_BOUNCED]: ORANGE,
  [NotificationTypes.EMAIL_UNSUBSCRIBED]: ORANGE,
  [NotificationTypes.PAGE_VIEWED]: GREEN,
  [NotificationTypes.CANDIDATE_IS_INTERESTED]: PURPLE,
  [NotificationTypes.CANDIDATE_ASK_QUESTION]: PURPLE,
  [NotificationTypes.CANDIDATE_NOT_INTERESTED]: PURPLE,
  [NotificationTypes.CANDIDATE_BOOK_INTERVIEW]: PURPLE,
  [NotificationTypes.CANDIDATE_GIVE_FEEDBACK]: PURPLE,
  [NotificationTypes.CANDIDATE_VIEW_MORE]: GREEN,
  [NotificationTypes.JOB_APPLY_CLICKED]: PURPLE,
  [NotificationTypes.JOB_APPLIED]: PURPLE,
};

const defaultAccent = GREEN;

export function getAccent(type) {
  return accentMap[type] || defaultAccent;
}

/**
 * Where a notification's call-to-action should navigate, or `null` when the
 * float/submission/job it refers to is missing (deleted, or not hydrated by
 * the API) — callers must hide the action rather than route to an undefined uuid.
 */
export function getActionHref(notification) {
  if (notification.submission?.uuid) return `/submissions/${notification.submission.uuid}`;
  if (notification.float?.uuid) return `/floats/${notification.float.uuid}`;
  if (notification.job?.uuid) return `/jobs/${notification.job.uuid}`;
  return null;
}

/** Label for that action, or `null` when there's nothing to link to. */
export function getActionLabel(notification) {
  if (notification.submission?.uuid) return "View submission";
  if (notification.float?.uuid) return "View float";
  if (notification.job?.uuid) return "View job";
  return null;
}

export const NOTIFICATION_TYPE_LABELS = {
  [NotificationTypes.EMAIL_OPENED]: "Email opened",
  [NotificationTypes.EMAIL_BOUNCED]: "Email bounced",
  [NotificationTypes.EMAIL_UNSUBSCRIBED]: "Email unsubscribed",
  [NotificationTypes.PAGE_VIEWED]: "Viewed",
  [NotificationTypes.CANDIDATE_IS_INTERESTED]: "Is interested",
  [NotificationTypes.CANDIDATE_ASK_QUESTION]: "Ask question",
  [NotificationTypes.CANDIDATE_NOT_INTERESTED]: "Not interested",
  [NotificationTypes.CANDIDATE_BOOK_INTERVIEW]: "Book interview",
  [NotificationTypes.CANDIDATE_GIVE_FEEDBACK]: "Give feedback",
  [NotificationTypes.CANDIDATE_VIEW_MORE]: "View more",
  [NotificationTypes.JOB_APPLY_CLICKED]: "Started applying",
  [NotificationTypes.JOB_APPLIED]: "Applied",
};
